import { useEffect, useState, useContext} from "react";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";
import { sortElements } from "@clodo/core";
import './App.css';
import Admin from "./Admin";
import LoginPage from "./LoginPage";
import RequireAuth from "./RequireAuth";
import FolderTree from './molecules/FolderTree/FolderTree';
import Breadcrumb from "./molecules/Breadcrumb/Breadcrumb";
import FileProgress from "./atoms/FileProgress";
import Uploader from "./services/Uploader";
import UploadBtn from "./atoms/buttons/UploadButton/UploadButton";
import NewFolderBtn from "./atoms/buttons/FolderButton/NewFolderButton";
import PlexRefreshButton from "./atoms/buttons/PlexButton/PlexRefreshButton";
import { BrowserContext } from "./services/BrowserContext";
import cssFolderTree from "./molecules/FolderTree/folderTree.module.css";
import Historical from "./molecules/History/Historical";
import Carousel from "./molecules/modals/Carousel";
import PasteButton from "./atoms/buttons/PasteButton/PasteButton";
import Profile from "./Profile";
import Content from "./Content";
import SortButton from "./atoms/buttons/SortButton/SortButton";
import Search from "./atoms/Search";

const elements = {'name' : 'Root', 'type' : 'folder', 'child' :[]};
//let currentFolder = elements;
const rootPath = [];
var uploader = new Uploader();

function parsePath(pathname){
    let path = decodeURI(pathname).split('/').slice(2);
    if(path.length === 1 && path[0] === ''){
        path = [];
    }
    return path;
}

function App() {
    //console.log('app');
    const navigate = useNavigate();
    const location = useLocation();
    const {itemsManipulator} = useContext(BrowserContext);
    const [searchLimit,setSearchLimit] = useState(50) ;
const handleSearchLimit = (newSearchLimit,add = false) =>{
        if(add){
            setSearchLimit(searchLimit+newSearchLimit);
        }else{
            setSearchLimit(newSearchLimit);
        }
    }
    const [isSearchFolder,setIsSearchFolder] = useState(false) ;
    const [sortType,setSortType] = useState("name") ;
    const [sortOrder,setSortOrder] = useState("asc") ;
    const [currentFolder,setCurrentFolder] = useState(elements) ;
    const handleCurrentFolder = (folder,isSearchFolder = false) => {
        setIsSearchFolder(isSearchFolder);
        // Les résultats de recherche gardent l'ordre du serveur (pertinence de
        // parcours) ; un vrai dossier est trié selon le critère courant.
        if(!isSearchFolder){
            sortElements(folder.child, sortType, sortOrder);
        }
        setCurrentFolder(folder);
    }
    const [currentPath,setPath] = useState([]) ;
    // Affiche un dossier déjà présent dans l'arbre `elements` (parcours + rendu),
    // et déclenche le fetch backend uniquement si `doFetch` est vrai (navigation).
    const showPath = (path,doFetch = false) => {
        itemsManipulator.path = path;
        if(doFetch){
            itemsManipulator.get(path);
        }
        let folder = elements;
        path.forEach(folderName => folder = folder && folder.child.find( element => element.name === folderName && element.type === 'folder'));
        if(!folder){
            // Contenu pas encore chargé : un fetch en cours re-déclenchera le rendu.
            return;
        }
        folder.child.forEach((element) => element.path = Array.from(path));
        handleCurrentFolder(folder);
        setPath(Array.from(path));
    }
    // Point d'entrée unique de navigation. Change l'URL si le chemin diffère
    // (React Router gère l'historique + back/forward), sinon recharge sur place.
    const handleCurrentPath = (path) => {
        // Sur /admin, les rafraîchissements internes (bootstrap init) ne doivent
        // pas rediriger : on rend dans l'état sans toucher à l'URL.
        if(location.pathname === '/login' || location.pathname.startsWith('/admin')){
            showPath(path);
            return;
        }
        if(decodeURI(location.pathname) !== '/root/'+path.join('/')){
            navigate('/root/'+path.join('/'));
        }else{
            showPath(path);
        }
    }

    const [fileInfo,setFileInfo] = useState(false) ;
    const handleFileInfo = (fileInfo) => setFileInfo(fileInfo);

    const [user,setUser] = useState(false) ;
    // 'checking' au démarrage (session en cours de vérification), puis 'authed'/'anon'.
    const [authStatus,setAuthStatus] = useState('checking') ;
    const handleUser = (user) => {
        setUser(user);
        setAuthStatus(user ? 'authed' : 'anon');
    };

    const [historical,setHistorical] = useState([]) ;
    const handleHistorical = (row) => {
        historical.push(row);
        setHistorical(Array.from(historical));
    }

    const [clipboardFile,setClipboardFile] = useState(null);
    const [clipboardAction,setClipboardAction] = useState(null);
    const handleClipboard = (fileName,action) => {
        setClipboardFile(fileName);
        setClipboardAction(action);
    }

    const [renameItemName,setRenameItemName] = useState(null);
    const handleRenameItemName = (name) => setRenameItemName(name);

    const [carouselActiveFileName,setCarouselActiveFileName] = useState(null);
    const handleCarouselActiveFileName = (name) => {
        setCarouselActiveFileName(name);
    }

    const [newFolder,setNewFolder] = useState(false) ;
    const handleNewFolder = (state) => setNewFolder(state);

    uploader.handleFileInfo = handleFileInfo;
    uploader.handleHistorical = handleHistorical;
    uploader.itemsManipulator = itemsManipulator;
    itemsManipulator.elements = elements;
    itemsManipulator.handleUser = handleUser;
    itemsManipulator.handleCurrentPath = handleCurrentPath;
    itemsManipulator.onExpired = () => setAuthStatus('anon');

    // Réagit à tout changement d'URL (clics, back/forward navigateur, deep-link)
    // et charge le dossier correspondant.
    useEffect(() => {
        if(location.pathname === '/login' || location.pathname.startsWith('/admin')) return;
        showPath(parsePath(location.pathname),true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[location.pathname]);

    useEffect(() => {
        itemsManipulator.path = parsePath(window.location.pathname);
        itemsManipulator.init();
    },[itemsManipulator]);

    useEffect(() => {
        handleCurrentFolder({...currentFolder});
        // eslint-disable-next-line
    },[sortOrder,sortType]);
    
  return (
    <BrowserContext.Provider value={{handleCurrentPath,handleCarouselActiveFileName,handleRenameItemName,handleClipboard,itemsManipulator}}>
      <Routes>
        <Route path="/login" element={<LoginPage authStatus={authStatus} />} />
        <Route path="/admin" element={<RequireAuth authStatus={authStatus}><Admin user={user} /></RequireAuth>} />
        <Route path="*" element={
          <RequireAuth authStatus={authStatus}>
        <div id="browser-container" className="container-fluid">
            <nav id="header" className="app-header">
                <span className="app-brand">
                    <i className="bi bi-hdd-stack app-brand-icon"></i>
                    <span className="app-brand-name">ClodoDrive</span>
                </span>
                <Profile user={user} handleUser={handleUser}></Profile>
            </nav>
            <div id="folderTree" className="border rounded bg-white">
                <div className={cssFolderTree.div+" ms-2"} onClick={(e)=> handleCurrentPath([])}>
                    <button className={cssFolderTree.button} data-bs-toggle="collapse" data-bs-target={"#root"} aria-expanded="true"><img alt="toggle" src="/assets/ico/toggle.svg"/></button>
                    <i className="bi bi-hdd"></i>
                    <p className={cssFolderTree.folderName}>Root</p>
                </div>
                <ul id="root" className="list-unstyled collapse show">
                    {
                        elements.child.map(folder => folder.type === 'folder'  ? <FolderTree parrentPath={rootPath} key={'/'+folder.name} name={folder.name} child={folder.child}/>  : null)
                    }
                </ul>
            </div>
            <div id="uploadList" className="folder border rounded bg-white">
                <Historical elements={historical}></Historical>
            </div>
            <nav id="breadcrumb" aria-label="breadcrumb" className="border rounded bg-white">
                <Breadcrumb path={currentPath}/>
            </nav>
            <div id="actionArea" className="d-flex flex-wrap gap-3">
                    <UploadBtn uploader={uploader} path={currentPath}/>
                    <NewFolderBtn handleNewFolder={handleNewFolder}/>
                    <PlexRefreshButton server={user.plex_server} port={user.plex_port} library={user.plex_library} token={user.plex_token}/>
                    <PasteButton filePath={clipboardFile} action={clipboardAction} currentPath={currentPath}></PasteButton>
                    <Search elements={elements} path={currentPath} handleCurrentFolder={handleCurrentFolder} limit={searchLimit} handleSearchLimit={handleSearchLimit}></Search>
            </div>
            
            <div className="bg-white border rounded" id="content" onDrop={e => uploader.dropFiles(e,currentPath)} onDragOver={e => e.preventDefault()}>
                <div className="row border-bottom p-3 fw-bold m-0">
                    <div className="col-md-8 col-lg-9 col-xl-10 d-flex">Name <SortButton setSortType={setSortType} setSortOrder={setSortOrder} sortOrder={sortOrder}></SortButton></div><div id="sizeHeader" className="col-md-4 col-lg-3 col-xl-2">Size</div>
                </div>
                <div id="content-items" className="list-group p-3 list-group-flush">
                    <Content elements={currentFolder} path={currentPath} newFolder={newFolder} handleNewFolder={handleNewFolder} renameItemName={renameItemName} isSearchFolder={isSearchFolder} handleSearchLimit={handleSearchLimit} limit={searchLimit}/>
                </div>
            </div>
            <div id="fileProgress">
                <FileProgress fileInfo={fileInfo}/>
            </div>
        </div>
        <Carousel elements={currentFolder} carouselActiveFileName={carouselActiveFileName}></Carousel>
          </RequireAuth>
        } />
      </Routes>
      </BrowserContext.Provider>
  );
}

export default App;
